/* 
 * 21.02.2018
 * NewCatController ile birlikte CategoryAndFilters.js yerine kullanılır
 * Infinity Scroll yerine Paging yapısına uygundur
 * $(document).ready 'nin üstünde bulunan fonksiyonlar açılışta çağrılır
 * $(document).ready 'nin altında bulunan fonksiyonlar event'lara bağlıdır, $(document).ready 'deki click olaylarıyla tetiklenir
 */

var date = new Date();
date.setTime(date.getTime() + (5 * 60 * 1000));

function ToggleLeftBar() {
    if ($(window).width() > 991) {
        $(".FilterForm .filterLink, .SubCatNavs .filterLink").live("click", function () {
            $(this).toggleClass("toggle-minus");
            $(this).parent().find(".FilterBoxes").slideToggle();
        });
    }
    else {
        $(".FilterForm .filterLink").live("click", function () {
            if ($(this).hasClass("toggle-minus")) {
                $(this).removeClass("toggle-minus");
                $(this).parent().find(".FilterBoxes").addClass("active");
            }
            else {
                $(this).addClass("toggle-minus");
                $(this).parent().find(".FilterBoxes").removeClass("active");
            }
        });
    }
}

function SetPriceSlider() {

    if ($(".CategoryLeftBar").length > 0 && $("#PgType").val() == "Cat") {

        var slider = document.getElementById('PriceSlider');
        var min = $("#MinPrice").val();
        var max = $("#MaxPrice").val();
        var currencySymbol = $("#CurrencySymbol").val();

        noUiSlider.create(slider, {
            start: [min, max],
            connect: true,
            step: 1,
            range: {
                'min': parseInt(min),
                'max': parseInt(max)
            }
        });

        slider.noUiSlider.on('change', function () {
            var values = slider.noUiSlider.get();
            $("#MinPrice").val(Math.round(values[0]));
            $("#MaxPrice").val(Math.round(values[1]));
            $("#SliderValue").val(Math.round(values[0]) + "-" + Math.round(values[1]));

            if (!isMobileResolution()) {
                $(".AppylArea .FilterApplyButton").trigger("click");
            }
        });

        slider.noUiSlider.on('update', function () {
            var values = slider.noUiSlider.get();
            $("#MinPrice").val(Math.round(values[0]));
            $("#MaxPrice").val(Math.round(values[1]));
            $(".priceView").html("").html(Math.round(values[0]) + " " + currencySymbol + "<span style='padding: 0px 40px;'></span> " + Math.round(values[1]) + " " + currencySymbol);
        });
    }
}

function LazyLoad() {
    $(".ProductList .Prd img.PImage, .ProductList .Prd .ProductListColor img").Lazy();
}

// Cookie Değerine Göre Açılış Grid'ini Ayarlama Fonksiyonu
function SetGridByCookie() {
    var cookieGrid = $.cookie("PRSgridCookie");
    if (cookieGrid == "" || cookieGrid == null || cookieGrid == undefined) {
        if (isMobileResolution()) {
            cookieGrid = "2";
        }
        else {
            cookieGrid = "4";
        }
        $.cookie("PRSgridCookie", "4", { path: '/' }, { expires: 7 });
    }

    if (!isMobileResolution()) { // Desktop grid ayarlama
        DesktopGridSet(cookieGrid);
    }
    else { // Mobile grid ayarlama        
        MobileGridSet(cookieGrid);
    }
}

// Açılışta QueryString'deki Filtreleme Seçeneklerini Kontrol Eder
function QueryStringControlForFilter() {

    var vars = [], hash;
    var selectedSize = "";
    var selectedColor = "";
    var selectedCatalog = "";
    var selectedDepartment = "";
    var selectedSeason = "";
    var selectedPrice = "";
    var selectedSoldOut = "";
    var selectedSort = "";
    var selectedPropertie = "";
    var selectedCloth = "";
    var selectedOnlOzl = "";
    var selectedMold = "";
    var selectedErpBadgeText = "";

    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur
    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'); // QueryString okunur ve Split eder

    if (NativeQueryFilter.indexOf("=") != "-1") {

        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "s") {
                selectedSize = hash[1]; // Size değerleri alınır
            }
            else if (hash[0] == "c") {
                selectedColor = hash[1]; // Color değerleri alınır
            }
            else if (hash[0] == "ct") {
                selectedCatalog = hash[1]; // katalog değerleri alınır
            }
            else if (hash[0] == "dp") {
                selectedDepartment = hash[1]; // Departman değerleri alınır
            }
            else if (hash[0] == "sea") {
                selectedSeason = hash[1]; // Departman değerleri alınır
            }
            else if (hash[0] == "prc") {
                selectedPrice = hash[1]; // Price değerini alınır
            }
            else if (hash[0] == "so") {
                selectedSoldOut = hash[1]; // Tükenenleri Gizle seçeneğini alır
            }
            else if (hash[0] == "o") {
                selectedSort = hash[1]; // Sıralama seçeneği alınır
            }
            else if (hash[0] == "prp") {
                selectedPropertie = hash[1]; // Sıralama seçeneği alınır
            }
            else if (hash[0] == "clh") {
                selectedCloth = hash[1]; // Sıralama seçeneği alınır
            }
            else if (hash[0] == "onlozl") {
                selectedOnlOzl = hash[1]; // Online Özel seçeneği alınır
            }
            else if (hash[0] == "mld") {
                selectedMold = hash[1]; // Kalıp seçeneği alınır
            }
            else if (hash[0] == "btxt") {
                selectedErpBadgeText = hash[1]; // Erp Badge Metin seçeneği alınır
            }
        }

        // Seçili Size'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedSize != null && selectedSize != "" && selectedSize != undefined) {
            var selectedSizes = selectedSize.split(',');

            $.each(selectedSizes, function (key, value) {
                $li = $("#Sizes li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Size'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Color'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedColor != null && selectedColor != "" && selectedColor != undefined) {
            var selectedColors = selectedColor.split(',');

            $.each(selectedColors, function (key, value) {
                $li = $("#Colors li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Color'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Katalog'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedCatalog != null && selectedCatalog != "" && selectedCatalog != undefined) {
            var selectedCatalogs = selectedCatalog.split(',');

            $.each(selectedCatalogs, function (key, value) {
                $li = $("#ProductGroup li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Katalog'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Departman'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedDepartment != null && selectedDepartment != "" && selectedDepartment != undefined) {
            var selectedDepartments = selectedDepartment.split(',');

            $.each(selectedDepartments, function (key, value) {
                $li = $("#Departments li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Departman'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Sezon'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedSeason != null && selectedSeason != "" && selectedSeason != undefined) {
            var selectedSeasons = selectedSeason.split(',');

            $.each(selectedSeasons, function (key, value) {
                $li = $("#Seasons li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Sezon'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Özelliklerin li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedPropertie != null && selectedPropertie != "" && selectedPropertie != undefined) {
            var selectedProperties = selectedPropertie.split(',');

            $.each(selectedProperties, function (key, value) {
                $li = $("#Properties li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Özelliklerin li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Kumaşların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedCloth != null && selectedCloth != "" && selectedCloth != undefined) {
            var selectedCloths = selectedCloth.split(',');

            $.each(selectedCloths, function (key, value) {
                $li = $("#Cloth li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Özelliklerin li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Price değer aralığını ayarlar
        if (selectedPrice != null && selectedPrice != "" && selectedPrice != undefined) {

            $("#SliderValue").val(selectedPrice);
            var SelectedPrices = selectedPrice.split('-');

            var slider = document.getElementById('PriceSlider');
            slider.noUiSlider.set([SelectedPrices[0], SelectedPrices[1]]);
        }
        // Seçili Price değer aralığını ayarlar

        // Seçiliyse tükenenleri gizle seçeneğini işaretler
        if (selectedSoldOut != null && selectedSoldOut != "" && selectedSoldOut != undefined && selectedSoldOut == "1") {
            $li = $("#SoldOutOp li.gr");
            $li.find("input").attr("checked", "checked");
            $li.find("input").val("1");
            $li.find("label").addClass("checked2");
        }
        // Seçiliyse tükenenleri gizle seçeneğini işaretler

        // Sıralama varsa dropdown'dan seçeneği işaretler
        if (selectedSort != null && selectedSort != "" && selectedSort != undefined) {

            $li = $("#PrdSort input[value='" + selectedSort + "']").parent("li");

            $li.find("label").addClass("checked");
            $li.find("label").addClass("c_on");

            $(".fLinkSortNo").html($li.find("label .checkText").html()); // Seçili sıralama seçeneğini gösterir
        }
        // Sıralama varsa dropdown'dan seçeneği işaretler

        // Online özel varsa seçeneği işaretler
        if (selectedOnlOzl != null && selectedOnlOzl != "" && selectedOnlOzl != undefined) {
            var selectedOnlOzls = selectedOnlOzl.split(',');

            $.each(selectedOnlOzls, function (key, value) {
                $li = $("#JustOnline li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }

        // Online özel varsa seçeneği işaretler

        // Kalıp varsa seçeneği işaretler
        if (selectedMold != null && selectedMold != "" && selectedMold != undefined) {
            var selectedMoldS = selectedMold.split(',');

            $.each(selectedMoldS, function (key, value) {
                $li = $("#Molds li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }

        // Kalıp varsa seçeneği işaretler

        // Erp Badge Metin varsa seçeneği işaretler
        if (selectedErpBadgeText != null && selectedErpBadgeText != "" && selectedErpBadgeText != undefined) {
            var selectedErpBadgeTextS = selectedErpBadgeText.split(',');

            $.each(selectedErpBadgeTextS, function (key, value) {
                $li = $("#ErpBadgeTexts li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }

        // Erp Badge Metin varsa seçeneği işaretler
    }

    GetSelectedFilter(); // Gelen filtreleri Seçili Filtreler alanına ekler
}

// Seçimleriniz alanını footer'da gizler
function HideChoices() {
    $(window).scroll(function (event) {
        var y = $(this).scrollTop();
        var height = 0;

        $(".FilterForm .col-md-24").not(".AppylArea").each(function () {
            height += $(this).height();
        });

        height = height - 700;

        if (y >= height) {
            $(".AppylArea").removeClass("AppylAreaFixed");

        } else {
            $(".AppylArea").addClass("AppylAreaFixed");
        }
    });
}

// Detaydan Listeleme Sayfasına Geri Dönmede Scroll Position'ı Ayarlar
function BackButtonLastScroll() {
    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var browserName = navigator.userAgent;
    if (browserName.indexOf("Chrome")) {
        browserName = "Chrome";
    }

    var pgType = $("#PgType").val();
    var lastScrollTop = $.cookie("lastScroll");
    var CatID = $("#PID").val();
    var lastScrollTopFirst = $.cookie("getLastScrollFirst");

    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur

    if (pgType == "Cat") {

        if (CatID != $.cookie("lastCatalogID")) {
            lastScrollTopFirst = 0;
            $.cookie("lastCatalogID", CatID, { path: '/', expires: date });
        }

        if (NativeQueryFilter.indexOf("=") != "-1") { // kataloğun ilk sayfası ise lastScroll'u dikkate almasın
            if (lastScrollTop != null && lastScrollTop != "" && lastScrollTop != undefined && lastScrollTop > 0) {

                var listHeight = $(".ProductList").height();
                lastScrollTop = lastScrollTop - (listHeight /** (currentPage - 1)*/);

                if (lastScrollTop > 0) {
                    $('html, body').animate({
                        scrollTop: lastScrollTop
                    }, 0);
                }
            }
        }

        //if (NativeQueryFilter.indexOf("=") != "-1") { // kataloğun ilk sayfası ise lastScroll'u dikkate almasın
        //    if (lastScrollTop != null && lastScrollTop != "" && lastScrollTop != undefined && lastScrollTop > 0) {
        //        setTimeout(function () {
        //            $('html, body').animate({
        //                scrollTop: lastScrollTop
        //            }, 0);
        //        }, 1000);
        //    }
        //}
        //else {

        //    if (lastScrollTopFirst != null && lastScrollTopFirst != "" && lastScrollTopFirst != undefined && lastScrollTopFirst > 0) {
        //        setTimeout(function () {
        //            $('html, body').animate({
        //                scrollTop: lastScrollTopFirst
        //            }, 0);
        //        }, 1000);
        //    }
        //}

        $.cookie("getLastScrollFirst", "0", { path: '/', expires: date });
        $.cookie("lastScroll", "0", { path: '/', expires: date });
    }
}

function getPenPath() {
    var vars = [], hash;
    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur
    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'); // QueryString okunur ve Split eder
    var currentPage = 1;

    if (NativeQueryFilter.indexOf("=") != "-1") {
        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "p") {
                currentPage = hash[1];
            }
        }
    }

    var params = GenerateParams("paging", (parseInt(currentPage) + 1) /*this.loadCount + 2*/); // Sayfalama için istek parametresi üretir
    if (params) {
        //return "/" + $("#SmallLangCode").val() + "/p/Home/GetProductList?" + params;
        return "?" + params;
    }
}

function InfinityScroll() {
    var $container = $('.ProductList').infiniteScroll({
        path: getPenPath,
        append: '.Prd',
        scrollThreshold: 500,
        checkLastPage: ".pageEnd"
    });
    var infScroll = $container.data('infiniteScroll');

    $container.on('load.infiniteScroll', function () {
        setTimeout(function () {
            LazyLoad();

            var cookieGrid = $.cookie("PRSgridCookie");
            if (isMobileResolution()) {
                MobileGridSet(cookieGrid);
            }
            else {
                DesktopGridSet(cookieGrid);
            }
        }, 2000);
    });
}

function IsFollowCategory() {
    if ($(".ProductList .Prd .QuickLookLikeBtn").length <= 0) {
        return;
    }

    $.ajax({
        type: 'get',
        url: getRequestRoute() + "/p/ProductDetails/IsFollowAll",
        dataType: 'json',
        async: true,
        success: function (dt) {
            updateList(dt);
        }
    });

    var updateList = function (dt) {
        $(".ProductList .Prd .QuickLookLikeBtn").removeClass("active");

        for (var i in dt) {
            var item = dt[i];

            var followlar = $(".ProductList .Prd .QuickLookLikeBtn").filter(function (index) {
                return $(this).attr("data-id") == item["ProductID"] && $(this).attr("data-colorid") == item["ColorID"];
            });

            if (followlar.length > 0) {
                var followItem = $(followlar[0]);
                followItem.addClass("active");
                followItem.find(".sorsfont").removeClass("sorsfont-favorite").addClass("sorsfont-favorite-o");

                //if (followItem.hasClass("active")) {
                //    followItem.children("img").attr("src", "/Images/OXNW/like_full.svg");
                //}
            }
        }
    };
}

function FollowProperty() {
    $(document).on("click", ".QuickLookLikeBtn:not(.active)", function () {
        var ProductID = $($(this)).attr("data-id");
        var ColorID = $($(this)).attr("data-colorid");
        button = $(this);
        GenerateLocalLoading(button.closest(".Prd"), "show");

        AddToFavorite(ColorID, ProductID, function (result, msg) {
            if (result == true) {
                button.addClass("active");
                button.find(".sorsfont").removeClass("sorsfont-favorite").addClass("sorsfont-favorite-o");
            }
            else {
                //SwalGenerate("error", msg, getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));

                var loginLink = getRequestRoute() + "/p/User/Login";

                SwalGenerate("warning", msg, getStandartMessages("IslemBasarisiz"), "<a href='" + loginLink + "'>" + getStandartMessages("GirisYap") + "</a>");
            }

            GenerateLocalLoading(button.closest(".Prd"), "hide");
        });
    });

    $(document).on("click", ".QuickLookLikeBtn.active", function () {
        var ProductID = $($(this)).attr("data-id");
        button = $(this);
        GenerateLocalLoading(button.closest(".Prd"), "show");

        removeFavorite(ProductID, function (result) {
            if (result == true) {
                button.removeClass("active");
                button.find(".sorsfont").removeClass("sorsfont-favorite-o").addClass("sorsfont-favorite");
            }
            else {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
            }

            GenerateLocalLoading(button.closest(".Prd"), "hide");
        });
    });
}
// ürünler
$(document).ready(function () {

    var PageType = $("#PgType").val();

    if (PageType == "Cat" || PageType == "Combine") {

        var InfinityScroll = $("#IsInfinity").val();

        if (InfinityScroll == "True") {
            $container = $('.ProductList').infiniteScroll({
                path: getPenPath,
                append: '.Prd',
                scrollThreshold: 500,
                checkLastPage: ".pageEnd"
            });
            var infScroll = $container.data('infiniteScroll');

            $container.on('load.infiniteScroll', function () {
                setTimeout(function () {
                    LazyLoad();

                    var cookieGrid = $.cookie("PRSgridCookie");
                    if (isMobileResolution()) {
                        MobileGridSet(cookieGrid);
                    }
                    else {
                        DesktopGridSet(cookieGrid);
                    }
                }, 1000);
            });

            BackButtonLastScroll();
        }
        else {
            BackButtonLastScroll(); // Detaydan Listeleme Sayfasına Geri Dönmede Scroll Position'ı Ayarlar
        }

        // Left/Filter Bar
        ToggleLeftBar();
        SetPriceSlider();

        LazyLoad(); // Lazy Load    
        SetGridByCookie(); // Cookie Değerine Göre Grid Ayarlama
        ClearAllFilter("false");
        QueryStringControlForFilter(); // QueryString'deki filtreleri kontrol eder

        if (!isMobileResolution()) {
            //HideChoices(); // Seçimleriniz alanını footer'da gizler(Sadece Desktop)
            //$(".CatBannerContainerMobile").remove();

            $(document).on("click", "#LeftWrapper .FilterBoxes li > label", function () {
                $(".AppylArea .FilterApplyButton").trigger("click");
            });

            var FilterAreaHeight = $(window).height() - $("header").height() - 50;
            $("#LeftWrapper").css("height", FilterAreaHeight + "px");

            $(window).resize(function () {
                setTimeout(function () {
                    var FilterAreaHeight = $(window).height() - $("header").height() - 50;
                    $("#LeftWrapper").css("height", FilterAreaHeight + "px");
                }, 500);
            });
        }
        else {
            //$(".CatBannerContainer").remove();

            // Backdrop tıklanınca filtre&sıralama alanı kapatılsın
            $(document).on("click", ".backdrop", function () {
                $(".MobilSortArea").slideUp("normal", function () {
                    $(".mobilFilterArea").removeClass("open");
                    $(".backdrop").removeClass("openFilter").removeClass("rightMenu");
                });
            });

            $(document).on("click", ".backdrop, .MobilSortArea #SortSelection .CloseSort", function () {
                $(".MobilSortArea").slideUp("normal", function () {
                    $(".backdrop").removeClass("openFilter");
                });
            });

            $(document).on("click", "#LeftWrapper .FilterArea .mobilFilterArea .MobilFilterHeader .headertitle i", function () {
                $(".MobilSortArea").slideUp("normal", function () {
                    $(".mobilFilterArea").removeClass("open");
                    $(".backdrop").removeClass("openFilter").removeClass("rightMenu");
                });
            });

            // Mobil filtre geri kaydırma
            $(document).on("click", ".FilterForm .FilterBoxes .MobileFilterHeader a", function () {
                $(this).parents(".FilterOption").removeClass("active");
                $(this).parents(".col-md-24").children(".filterLink").addClass("toggle-minus");
            });
        }

        BrowserBackAndPrevButtonControl(); // Browser iler/geri tuşları tetiklenince çalışır
        IsFollowCategory();
        FollowProperty();

        if ($(".ProductList.NotFoundContainer .NotFound").length > 0) {
            var LastVisitedPrds = GetLastVisitedData();

            if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {
                GetLastVisitedPrdView(LastVisitedPrds, function (dt) {
                    if (dt != "") {
                        $(".ProductList.NotFoundContainer .SuggestedProductsContainer .AutoGetLastVisited").append(dt);
                        SlickSlider("suggested");
                    }
                });
            }
        }
    }

    $(".ToggleFilterBtn").live("click", function (e) {
        $(".CategoryLeftBar").toggleClass("filtreGizli");
        $(".ProductColumn").toggleClass("col-md-20");
        $(".ToggleFilterBtn").toggleClass("filtreBtnAcik");
    });

    $(document).on("click", ".ProductList .Prd .AddToCartArea button.AddToCart", function () {
        var $basketButton = $(this);
        var SizeID = $basketButton.attr("data-sizeid");
        var ColorID = $basketButton.attr("data-colorid");
        var ProductID = $basketButton.attr("data-productid");
        var LangID = $("#SmallLangCode").val();

        if (SizeID === "0") {
            if (isMobileResolution()) { 
                openSizeModal($basketButton, ProductID, ColorID);
            } else { 
                var params = 'ColorID=' + ColorID + "&ProductID=" + ProductID;
                GetSizeOfColor(params, function (data) {
                    showSizeList($basketButton, data);
                    $basketButton.closest("div.AddToCartArea").children(".TransformContainer").addClass("select-size");
                });
            }
        } else {
            var param = 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + 1 + "&langID=" + LangID;

            GenerateLocalLoading($basketButton.parents(".Prd"), "show");
            AddToCard(param, function (dt) {
                if (dt.Sonuc == true) {
                    GetSepetIcerik(function (dt) {
                        setTimeout(function () {
                            $basketButton.closest("div.AddToCartArea").children(".TransformContainer").removeClass("select-size");
                        }, 500);

                        $basketButton.attr("data-sizeid", "0");
                        $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").html("");

                        $("#UserAndBasket").html(dt);

                        if ($(window).width() > 991) {
                            toggleBasket(true);

                            // 5 sn. sonra kapansın                                
                            setTimeout(function () {
                                if ($("body").hasClass("BasketDropped")) {
                                    toggleBasket();
                                }
                            }, 5000);
                        }

                        GenerateLocalLoading($basketButton.parents(".Prd"), "hide");

                        Swal.fire({
                            icon: 'success',
                            title: 'Ürün sepete eklendi!',
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            toast: true,
                            timerProgressBar: true,
                            customClass: 'swal-success-addtocart'
                        });
                    });
                } else {
                    SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
                    GenerateLocalLoading($basketButton.parents(".Prd"), "hide");
                }
            });
        }

        return false;
    });


    $(document).on("click", ".ProductListSizeContainer div.ProductListSize:not(.passive)", function () {
        var $currentColor = $(this);
        var sizeID = $(this).attr("data-size");

        $currentColor.closest(".Prd").find(".AddToCart").attr("data-sizeid", sizeID);
        $currentColor.closest(".ProductListSizeContainer").find(".ProductListSize").removeClass("active");
        $currentColor.addClass("active");
        $currentColor.closest(".Prd").find(".AddToCart").click();

        var $container = $currentColor.closest(".AddToCartArea").find(".TransformContainer");
        $container.removeClass("select-size");
        $container.css('width', '60px');
    });

    $(document).on("click", ".ProductListColorContainer div.ProductListColor:not(.passive)", function () {
        var $currentColor = $(this);

        var productID = $(this).attr("data-color-product-id");
        var colorID = $(this).attr("data-color");
        var item_unique_id = $(this).attr("data-item-unique-id");
        var sizeID = $(this).attr("data-size");
        var params = "ColorID=" + colorID + "&ProductID=" + productID;

        if (typeof sizeID === "undefined") {
            sizeID = 0;

            var $detailLinks = $(this).closest(".Prd").find("a");
            $currentColor.closest(".ProductListColorContainer").find(".ProductListColor").removeClass("active");
            $currentColor.addClass("active");

            GetImageOfColors(params, item_unique_id, $currentColor);

            $currentColor.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").html("");
            $currentColor.closest(".AddToCartArea").find(".TransformContainer").removeClass("select-size");
        }
    });

    $(document).on("click", ".ProductList .Prd", function (e) {
        var ScrollContentID = "LastScrollTop" + $("#PID").val();
        $.cookie(ScrollContentID, null, { expires: -1 });
        $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });
    });

    function showSizeList($button, data) {
        var $sizeContainer = $button.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize");
        $sizeContainer.html(data).show();
        adjustContainerWidth($button);
    }
    function adjustContainerWidth($button) {
        var $container = $button.closest(".TransformContainer");
        var $sizeContainer = $container.find(".ProductListSizeContainer");
        var $sizes = $sizeContainer.find(".ProductListSize");
        var sizeCount = $sizes.length;

        if (sizeCount === 0) return;


        var totalWidth = 0;
        $sizes.each(function () {
            totalWidth += $(this).outerWidth(true);
        });

        var buttonWidth = 50;
        var newWidth = totalWidth + buttonWidth;
        newWidth = Math.min(newWidth, 340);

        $container.css('width', newWidth + 'px');
        $sizeContainer.css('flex-wrap', 'wrap'); // Flex yapıyı aktifleştir
    }

    if (isMobileResolution()) {
        var selectedSize = "";
        function openSizeModal($button, productID, colorID) {
            selectedSize = "";
            var params = 'ColorID=' + colorID + "&ProductID=" + productID;

            var productImage = $button.closest('.Prd').find('.PImage').attr('data-img') || $button.closest('.Prd').find('.PImage').attr('src');
            var productName = $button.closest('.Prd').find('.PName').text();
            var oldPrice = $button.closest('.Prd').find('.PPOldPrice').text();
            var productPrice = $button.closest('.Prd').find('.PPrice:not(.PPOldPrice)').text();
            var productColor = $button.closest('.Prd').find('.ProductListColor.active').attr('title');

            GetSizeOfColor(params, function (sizeDataHtml) {
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = sizeDataHtml;
                var sizeElements = tempDiv.querySelectorAll('.ProductListSize');

                var modalHtml =
                    '<div class="size-modal-overlay" id="sizeModalOverlay"></div>' +
                    '<div class="size-modal" id="sizeModal">' +
                    '<div style="text-align:right;"><button id="closeModalButton">&times;</button></div>' +
                    '<div class="product-info">' +
                    '<img src="' + productImage + '" />' +
                    '<p><strong>Ürün Adı:</strong> ' + productName + '</p>' +
                    '<p><strong>Renk:</strong> ' + productColor + '</p>';

                if (oldPrice) {
                    modalHtml += '<p><strong>Fiyat: </strong>' +
                        '<span style="text-decoration: line-through; margin-right: 10px; color: black;">' + oldPrice + '</span>' +
                        '<span>' + productPrice + '</span></p>';
                } else {
                    modalHtml += '<p><strong>Fiyat: </strong><span>' + productPrice + '</span></p>';
                }

                modalHtml += '</div>' +
                    '<h3>Beden Seçimi</h3>' +
                    '<div id="sizeOptions">';

                if (sizeElements.length > 0) {
                    Array.prototype.forEach.call(sizeElements, function (sizeElement) {
                        var sizeID = sizeElement.getAttribute('data-size');
                        var sizeTitle = sizeElement.querySelector('span').textContent;

                        var passiveClass = sizeElement.classList.contains('passive') ? 'disabled' : '';

                        modalHtml += '<button class="sizeOption' + passiveClass + '" data-size="' + sizeID + '" ' + (passiveClass ? 'disabled' : '') + '>' + sizeTitle + '</button>';
                    });
                } else {
                    modalHtml += '<p>Bu renkte uygun beden bulunmamaktadır.</p>';
                }

                modalHtml += '</div>' +
                    '<button id="confirmSizeSelection">Seçimi Onayla</button>' +
                    '</div>';

                document.body.insertAdjacentHTML('beforeend', modalHtml);

                $(document).on("click", ".sizeOption:not(.disabled)", function () {
                    selectedSize = $(this).attr("data-size");


                    $(".sizeOption:not(.disabled)").removeClass("selected").css({
                        "background-color": "transparent",
                        "color": "black",
                        "border": "1px solid black",
                        "outline": "none"
                    });


                    $(this).addClass("selected").css({
                        "background-color": "#000",
                        "color": "#fff",
                        "outline": "none",
                        "box-shadow": "none"
                    });
                });

                $(document).off("click", "#confirmSizeSelection").on("click", "#confirmSizeSelection", function () {

                    var $confirmButton = $(this);
                    if (selectedSize) {
                        $confirmButton.prop("disabled", true);

                        $button.attr("data-sizeid", selectedSize);
                        var ColorID = $button.attr("data-colorid");
                        var ProductID = $button.attr("data-productid");
                        var LangID = $("#SmallLangCode").val();

                        var param = 'sizeID=' + selectedSize + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=1" + "&langID=" + LangID;

                        GenerateLocalLoading($button.parents(".Prd"), "show");
                        AddToCard(param, function (dt) {
                            if (dt.Sonuc == true) {
                                GetSepetIcerik(function (dt) {
                                    setTimeout(function () {
                                        $button.closest("div.AddToCartArea").children(".TransformContainer").removeClass("select-size");
                                    }, 500);

                                    $button.attr("data-sizeid", "0");
                                    $button.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").html("");

                                    $("#UserAndBasket").html(dt);

                                    GenerateLocalLoading($button.parents(".Prd"), "hide");
                                    closeModal();

                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Ürün sepete eklendi!',
                                        position: 'top-end',
                                        showConfirmButton: false,
                                        timer: 3000,
                                        toast: true,
                                        timerProgressBar: true,
                                        customClass: 'swal-success-addtocart'
                                    });

                                });
                            } else {
                                SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
                                GenerateLocalLoading($button.parents(".Prd"), "hide");
                                closeModal();
                            }
                        });
                    } else {
                        SwalGenerate("info", "Lütfen Beden Seçip Tekrar Deneyiniz.", "BEDEN SEÇMEDİNİZ", "Kapat");
                    }
                });

                $(document).on("click", "#closeModalButton", function () {
                    closeModal();
                });

                $(document).on("click", "#sizeModalOverlay", function () {
                    closeModal();
                });
            });
        }

        function closeModal() {
            $("#sizeModal").remove();
            $("#sizeModalOverlay").remove();
            selectedSize = "";
        }
    } else {
        $(document).on("mouseenter", ".ProductList .Prd .AddToCartArea button.AddToCart", function () {
            var $basketButton = $(this);
            var sizeContainer = $basketButton.closest("div.AddToCartArea").find(".ProductListSizeContainer");
            var SizeID = $basketButton.attr("data-sizeid");
            var ColorID = $basketButton.attr("data-colorid");
            var ProductID = $basketButton.attr("data-productid");

            if (!$basketButton.hasClass("passive") && SizeID === "0") {
                if (sizeContainer.children().length == 0) {
                    var params = 'ColorID=' + ColorID + "&ProductID=" + ProductID;

                    GetSizeOfColor(params, function (data) {
                        showSizeList($basketButton, data);
                        $basketButton.closest("div.AddToCartArea").children(".TransformContainer").addClass("select-size");
                    });
                }
                else {
                    $basketButton.closest("div.AddToCartArea").children(".TransformContainer").addClass("select-size");

                    sizeContainer.show();
                    adjustContainerWidth($basketButton);
                }
            }
        });

        $(document).on("mouseleave", ".AddToCartArea .TransformContainer, .AddToCartArea .ProductListSizeContainer", function () {
            var $container = $(this).closest(".TransformContainer");
            $container.removeClass("select-size");
            $container.css('width', '60px');
        });
    }
    // End Ürünler

    // Renk ve Beden Filteri
    $('#Colors > li, #Sizes > li, #Properties > li, #Cloth > li, #ProductGroup > li, #Departments > li, #Seasons > li, #JustOnline > li, #Molds > li, #ErpBadgeTexts > li').click(function (event) {
        FilterItemSelect($(this));
    });

    // Seçili Filtre Alanını Açıp/Kapatır
    //$(".SelectedFilter .SelectedFilterHeader").click(function (event) {
    //    if ($(window).width() > 767) {
    //        var status = $(".SelectedFilter .SelectedFilterBody").hasClass("closed");
    //        var sendEvent = "";

    //        if (status == false) {
    //            sendEvent = "Down";
    //        }
    //        else {
    //            sendEvent = "Up";
    //        }

    //        if (sendEvent != null && sendEvent != "" && sendEvent != undefined) {
    //            OpenCloseSelectedFilterArea(sendEvent);
    //        }
    //    }
    //});

    // Seçili Filtreler Alanındaki Filteri Kaldırma
    $(".SelectedFilterCancelIcon").live("click", function () {
        var selectedVal = $(this).attr("data-value");
        var selectedType = $(this).attr("data-type");

        console.log("selectedVal: " + selectedVal);
        console.log("selectedType: " + selectedType);

        ClearSelectedFilter(selectedVal, selectedType);
    });

    // Tüm Filtreleri Kaldırır
    $(".SelectedFilter .ClearAllFilter").live("click", function () {
        ClearAllFilter("true");
    });

    // Tükenenleri Gizle
    $('#SoldOutOp > li.gr input').click(function (event) {
        SoldOutFilter($(this));
    });

    // Sıralama
    $('#PrdSort > li input').click(function (event) {
        ProductSort($(this));
    });

    // Desktop Grid Seçimi
    $(".mGridIcons-2, .mGridIcons-3, .mGridIcons-4").click(function () {
        var gridID = $(this).attr("data-gridvalue");

        if (gridID != null && gridID != undefined && gridID != "") {
            DesktopGridSet(gridID);
        }
    });

    // Mobile Grid Seçimi
    $(".gridAyarla").click(function () {
        if (isMobileResolution()) {
            var gridID = $(this).attr("data-grid");
            cookieGrid = $.cookie("PRSgridCookie");

            if (gridID != null && gridID != undefined && gridID != "") {
                MobileGridSet(gridID);
                $.cookie("PRSgridCookie", gridID, { path: '/' });
            }
        }
    });

    // Yeni Açının Çağrılması
    $(document).on("slid.bs.carousel", ".ProductList .Prd .PrdImgsBox .carousel", function () {
        var ImageSrc = $(this).find(".carousel-item.active").find("img").attr("src");
        $nextOrPrevImage = $(this).find(".carousel-item.active").find("img");

        if (ImageSrc != undefined && ImageSrc.indexOf("lazy_back_new.jpg") != -1) {
            $nextOrPrevImage.attr("src", $nextOrPrevImage.attr("data-img"));
        }
    });

    $(document).on("swiperight", ".ProductList .Prd .PrdImgsBox .carousel", function () {
        $(this).carousel('prev');
    });

    $(document).on("swipeleft", ".ProductList .Prd .PrdImgsBox .carousel", function () {
        $(this).carousel('next');
    });

    // Paging İsteği
    $(".Pages a, #nextPage a").live("click", function () {
        var pageNo = $(this).attr("data-pgno");

        $.cookie("lastScroll", 0, { path: '/', expires: date });
        $.cookie("getLastScrollFirst", 0, { path: '/', expires: date });

        if (pageNo != null && pageNo != undefined && pageNo != "") {
            getPageByPageNo(pageNo, "false");
        }
    });

    // Ürün'e Tıklandığında Scroll Position Alınır
    $(".ProductList a img:not(.NextPageImg)").live("click", function () {
        var lastScroll = $(window).scrollTop();
        var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur

        if (NativeQueryFilter.indexOf("=") != "-1") {
            $.cookie("lastScroll", lastScroll, { path: '/', expires: date });
        }
        else {
            $.cookie("getLastScrollFirst", lastScroll, { path: '/', expires: date });
        }
    });

    // Filtreleme İsteği
    $(".AppylArea .FilterApplyButton").live("click", function () {
        GetPageByFilter();
    });

    // Kategori Açıklama Yazısını Gösterir
    $('.CatShowMore, .CatShowLess').on('click', function (e, index) {
        var Clicked = $(this).attr("class");
        CatDescShowOrHide(Clicked);
    });

    // Mobil İçin Filtre ve Sıralama Alanını Açar
    $(".OpenFilterOrSortArea").click(function () {
        var area = $(this).parent().hasClass("FilterDiv"); // Tıklanan butonun filtre mi sıralama mı olduğuna mı bakılıyor

        if (area == true) {
            MobilSortFilterAreaOpenOrClose(".mobilFilterArea");
        }
        else {
            MobilSortFilterAreaOpenOrClose(".MobilSortArea");
        }
    });

    // Filter Search
    $(".SearchInList .SearchFilter").keyup(function () {
        var input, filter, txtValue, li;
        input = $(this).val();
        filter = input.toLocaleLowerCase();
        li = $(this).parents(".First").find(".FilterOption > ul > li");

        li.each(function (index) {
            txtValue = $(this).find("input[type='checkbox']").first().attr("data-rel");

            if (txtValue.toLocaleLowerCase().indexOf(filter) > -1) {
                $(this).css("display", "block");
            } else {
                $(this).css("display", "none");
            }
        });
    });

    // Mobil İçin Filtre ve Sıralama Alanını Kapatır
    //$(".CloseFilterOrSortArea").click(function () {
    //    var area = $(this).hasClass("CloseFilter"); // Tıklanan butonun filtre mi sıralama mı olduğuna mı bakılıyor

    //    if (area == true) {
    //        MobilSortFilterAreaOpenOrClose(".mobilFilterArea", "Close");
    //    }
    //    else {
    //        MobilSortFilterAreaOpenOrClose(".MobilSortArea", "Close");
    //    }
    //});
});


// Kategori Açıklama Yazısını Açıp/Kapatır
function CatDescShowOrHide($event) {
    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "CatShowMore") {
            $(".CatShowMore").hide();
            $('.CatShowLess').show();
            $('.CatSecondPart').show();
            $('.CatShortPart').hide();
        }
        else {
            $(".CatShowLess").hide();
            $('.CatShowMore').show();
            $('.CatSecondPart').hide();
            $('.CatShortPart').show();
        }
    }
}

// Filteleri seçili yapar
function FilterItemSelect($GroupName) {
    $li = $GroupName;

    if ($li.find("input:checked").length > 0) {

        $li.find("input").removeAttr("checked");
        $li.removeClass("selected");
        $li.find("label").removeClass("c_on");
    }
    else {
        $li.find("input").attr("checked", "checked");
        $li.addClass("selected");
        $li.find("label").addClass("c_on");
    }

    $li.find("input").trigger("change");
}

// Seçili Filtre Alanını Açıp/Kapatan Fonksiyon (Up/Down değeri alır)
function OpenCloseSelectedFilterArea($event) {
    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "Up") {
            $(".SelectedFilterBody").slideDown("slow");
            $(".SelectedFilter .SelectedFilterBody").removeClass("closed");
            $(".SelectedFilter").show();
        }
        else if ($event == "Down") {
            $(".SelectedFilterBody").slideUp("slow");
            $(".SelectedFilter .SelectedFilterBody").addClass("closed");
            $(".SelectedFilter").hide();
        }
    }
}

// Tükenenleri Gizle Seçeneğini Kontrol Eden Fonksiyon
function SoldOutFilter($soldOut) {

    $li = $soldOut.parent();

    if ($li.find("input").val() == "0") {
        $li.find("label").addClass("checked2");
        $li.find("input").val("1");
        GetPageByFilter();
    }
    else {
        $li.find("label").removeClass("checked2");
        $li.find("input").val("0");

        var currentPage = $(".Pages a.selected").attr("data-pgno");
        getPageByPageNo(currentPage, "false");
    }

}

// Sıralama Seçeneğini Kontrol Eden Fonksiyon
function ProductSort($selectedSort) {

    $li = $selectedSort.parent();

    // Tüm seçenekleri kapatır
    $("#PrdSort input").removeAttr("checked");
    $("#PrdSort label").removeClass("checked");
    $("#PrdSort label").removeClass("c_on");

    // Kullanıcının istediği seçeneği seçili yapar
    $li.find("label").addClass("checked");
    $li.find("label").addClass("c_on");

    // Sıralama ekranını kapatır
    $(".fLinkSortNo").removeClass("toggle-minus");
    $("#PrdSort").parent().hide();

    $(".fLinkSortNo").html("<i class='sorsfont sorsfont-slide-bar'></i>" + $li.find("label .checkText").html()); // Seçili sıralama seçeneğini gösterir

    var currentPage = "1";

    if ($("#IsInfinity").val() == "False") {
        if ($(".Pages a.selected").length > 0) {
            currentPage = $(".Pages a.selected").attr("data-pgno"); // Kullanıcının bulunduğu sayfa alınır
        }
        else {
            currentPage = 1;
        }
    }

    getPageByPageNo(currentPage, "false");

    if (isMobileResolution()) {
        MobilSortFilterAreaOpenOrClose(".MobilSortArea");
    }
}

// Desktop Grid Seçim Fonksiyonu
function DesktopGridSet($gridSize) {

    var removeClass = "";
    var addClass = "";
    var ActiveIcons = "";
    var PasiveIcons = "";
    var AddToCartAreaWidth = "";
    var gridValue = "";
    var selectedGridClass = "";
    var deSelectedGridClass = "";
    var PageType = $("#PgType").val();

    if ($gridSize == "2") {
        removeClass = "col-lg-6 col-xl-6";
        addClass = "col-lg-12 col-xl-12";
        ActiveIcons = "grid-color";
        PasiveIcons = "sorsfont-2-grid";
        AddToCartAreaWidth = "96%";
        gridValue = "2";
        selectedGridClass = ".mGridIcons-" + gridValue;
        deSelectedGridClass = ".mGridIcons-4";
        deSelectedRemoveIcons = "grid-color";
        deSelectedAddIcons = "sorsfont-4-grid";
    }
    else {
        removeClass = "col-lg-12 col-xl-12";
        addClass = "col-lg-6 col-xl-6";
        ActiveIcons = "grid-color";
        PasiveIcons = "sorsfont-4-grid";
        AddToCartAreaWidth = "92%";
        gridValue = "4";
        selectedGridClass = ".mGridIcons-" + gridValue;
        deSelectedGridClass = ".mGridIcons-2";
        deSelectedRemoveIcons = "grid-color";
        deSelectedAddIcons = "sorsfont-2-grid";
    }


    if (PageType != null && PageType != "" && PageType != undefined && PageType != "Combine") {
        $(".PrdContainer .ProductList .Prd").removeClass(removeClass).addClass(addClass);
        //$(selectedGridClass).css("background-image", "url(" + ActiveIcons + ")");
        $(selectedGridClass).find(".sorsfont ").addClass(ActiveIcons).removeClass(PasiveIcons);
        $(deSelectedGridClass).find(".sorsfont ").removeClass(deSelectedRemoveIcons).addClass(deSelectedAddIcons);
        //$(".PrdContainer .Prd .AddToCartArea").css("width", AddToCartAreaWidth);
    }
    else if (PageType != "Combine") {
        $(".PrdContainer .ProductList .Prd").addClass("col-lg-12 col-xl-12");
    }

    $.cookie("PRSgridCookie", gridValue, { path: '/' });
}

// Mobile Grid Seçim Fonksiyonu
function MobileGridSet($gridSize) {
    $(".gridAyarla i").removeClass("grid-color");

    if ($gridSize == "2") {
        $(".PrdContainer .ProductList .Prd").removeClass("col-24").addClass("col-12");
        $(".PrdContainer .ProductList .Prd .carousel .carousel-indicators").css("left", "75%");
        $(".gridAyarla.grid2 i").addClass("grid-color");
    }
    else {
        $(".PrdContainer .ProductList .Prd").removeClass("col-12").addClass("col-24");
        $(".PrdContainer .ProductList .Prd .carousel .carousel-indicators").css("left", "85%");
        $(".gridAyarla.grid1 i").addClass("grid-color");
    }
}

// Filtreleme Ve Sayfa Geçişlerinde Loader Gösterip Gizler
function ShowOrHideBackDrop($event) {
    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "show") {
            $(".backdrop").addClass("ShowBackdrop");
            $(".LoadingGif").show();
        }
        else if ($event == "hide") {
            $(".backdrop").removeClass("ShowBackdrop");
            $(".LoadingGif").hide();
        }
    }
}

// Paging İçin Ajax
function getPageByPageNo($pageNo, $IsBack) {
    if ($pageNo != null && $pageNo != "" && $pageNo != undefined && $pageNo != "0") {

        if ($IsBack != null && $IsBack != "" && $IsBack != undefined && $IsBack == "false") {
            GenerateUrlHistoy(); // URL History oluşturur
        }

        ShowOrHideBackDrop("show"); // Loader gösterilir

        var newScrollPosition = $(".Products").position(); // Filtreleme&Sayfalama işleminden sonra scroll'un gideceği position değeri
        if ($IsBack == "false") {
            $('html, body').animate({ // Listenin başına döndürür
                scrollTop: 0 //newScrollPosition.top
            }, 0);
        }

        var params = GenerateParams("paging", $pageNo); // Sayfalama için istek parametresi üretir

        $.ajax({
            type: "GET",
            url: getRequestRoute() + "/p/Home/GetProductList",
            data: params,
            cache: false,
            success: function (data) {

                ShowOrHideBackDrop("hide"); // Loader kapatılır

                SetUrl(params);

                if ($(".ProductList .NotFound").length <= 0) {
                    var IsInfinity = $("#IsInfinity").val();

                    if (IsInfinity == "True") {
                        $container.infiniteScroll('destroy');
                        $(".Products").html(data);
                        InfinityScroll();
                        LazyLoad();
                    }
                    else {
                        $(".Products").html(data);
                        LazyLoad();
                    }

                    IsFollowCategory();
                }

                var cookieGrid = $.cookie("PRSgridCookie");
                if (isMobileResolution()) {
                    MobileGridSet(cookieGrid);
                }
                else {
                    DesktopGridSet(cookieGrid);
                }

                //#region InsiderObject
                //var InsiderObjectBegin = data.indexOf("<!--InsiderObject-") + "<!--InsiderObject-".length;
                //var InsiderObjectEnd = data.indexOf("-InsiderObject-->") - "-InsiderObject-->".length;

                //var InsiderObjectCode = data.substr(InsiderObjectBegin, InsiderObjectEnd).replace("-InsiderObject-->", "").replace("<!--InsiderObject-", "");

                //if (InsiderObjectCode != undefined && InsiderObjectCode.length > 0) {
                //    window.insider_object = JSON.parse(InsiderObjectCode);
                //}

                //data = data.replace(InsiderObjectCode, "").replace("-InsiderObject-->", "").replace("<!--InsiderObject-", "");
                //#endregion InsiderObject
                ProductClickForDataLayer();

            },
            error: function () {
                ShowOrHideBackDrop("hide"); // Loader kapatılır
            }
        });

    }
}

// Filter İçin Ajax
function GetPageByFilter() {
    var newScrollPosition = $(".Products").position(); // Filtreleme&Sayfalama işleminden sonra scroll'un gideceği position değeri

    $('html, body').animate({ // Listenin başına döndürür
        scrollTop: 0 // newScrollPosition.top
    }, 0);

    var params = GenerateParams("filter"); // Filtreleme için istek parametresi üretir

    var loadingArea = $("body");

    //if (isMobileResolution) {
    //    loadingArea = $(".mobilFilterArea");
    //}

    GenerateLocalLoading(loadingArea, "show");

    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/Home/GetProductList",
        data: params,
        cache: false,
        success: function (data) {

            //#region InsiderObject
            //var InsiderObjectBegin = data.indexOf("<!--InsiderObject-") + "<!--InsiderObject-".length;
            //var InsiderObjectEnd = data.indexOf("-InsiderObject-->") - "-InsiderObject-->".length;
            //
            //var InsiderObjectCode = data.substr(InsiderObjectBegin, InsiderObjectEnd).replace("-InsiderObject-->", "").replace("<!--InsiderObject-", /"");
            //
            //if (InsiderObjectCode != undefined && InsiderObjectCode.length > 0) {
            //    window.insider_object = JSON.parse(InsiderObjectCode);
            //}
            //
            //data = data.replace(InsiderObjectCode, "").replace("-InsiderObject-->", "").replace("<!--InsiderObject-", "");
            //#endregion InsiderObject

            SetUrl(params);

            var IsInfinity = $("#IsInfinity").val();

            if (IsInfinity == "True") {
                $container.infiniteScroll('destroy');
                $(".Products").html(data);
                InfinityScroll();
                LazyLoad();
            }
            else {
                $(".Products").html(data);
                LazyLoad();
            }

            IsFollowCategory();

            var cookieGrid = $.cookie("PRSgridCookie");

            if ($(".SuggestedProductsContainer").length > 0) {
                SetLastVisitedProductsStorage();
            }

            if (isMobileResolution()) {
                $(".mobilFilterArea").removeClass("open");
                $(".backdrop").removeClass("rightMenu");
                MobileGridSet(cookieGrid);
                GetSelectedFilter();
            }
            else {
                GetSelectedFilter();// Seçimleriniz Alanına Seçili Filtreleri Ekler
                DesktopGridSet(cookieGrid);
            }

            var TotalCount = $("#ProductCountTotal").text();

            $(".TotalProductCount").text(TotalCount + " Ürün");

            GenerateLocalLoading(loadingArea, "hide");
        },
        error: function () {
            GenerateLocalLoading(loadingArea, "hide");
        }
    });
}

// Filtreleme Ve Sayfalama İsteklerinde Parametre Oluşturur
function GenerateParams($action, $pageNo) {
    var params = "";

    if ($action != null && $action != "" && $action != undefined) {

        // Sayfa Numarasını Ayarlar
        if ($action == "paging") {
            params = "p=" + $pageNo;
        }
        else if ($action == "filter") {
            params = "p=1";
        }
        // Sayfa Numarasını Ayarlar

        var CatalogPart = "&ct=" + $("#PID").val(); // Catalog ID'sini alır

        if ($("#ProductGroup input[type='checkbox']:checked").length > 0) {
            CatalogPart = "&ct=";

            $("#ProductGroup input[type='checkbox']:checked").each(function (index) {
                CatalogPart += $(this).val() + ",";
            });

            CatalogPart = CatalogPart.substring(0, CatalogPart.length - 1);
        }

        params += CatalogPart;

        // Departman Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedDepartment = "";
        $("#Departments li.selected").each(function (index) { // Seçili renkleri döndürür
            SelectedDepartment += $(this).children("input").val() + ",";
        });

        if (SelectedDepartment != "" && SelectedDepartment != null && SelectedDepartment != undefined) {
            params += "&dp=" + SelectedDepartment.substring(0, SelectedDepartment.length - 1); // Substring ile sondaki virgül silinir
        }
        // Departman Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Sezon Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedSeason = "";
        $("#Seasons li.selected").each(function (index) { // Seçili renkleri döndürür
            SelectedSeason += $(this).children("input").val() + ",";
        });

        if (SelectedSeason != "" && SelectedSeason != null && SelectedSeason != undefined) {
            params += "&sea=" + SelectedSeason.substring(0, SelectedSeason.length - 1); // Substring ile sondaki virgül silinir
        }
        // Sezon Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Cookide kayıtlı grid değeri varsa onu ekler
        cookieGrid = $.cookie("PRSgridCookie");
        if (cookieGrid != null && cookieGrid != "" && cookieGrid != undefined) {
            params += "&g=" + cookieGrid;
        }
        // Cookide kayıtlı grid değeri varsa onu ekler

        // Tükenenleri Gizle Seçeneğini Kontrol Eder
        var SoldOut = $("#SoldOutOp li input").val();
        if (SoldOut == "1") {
            params += "&so=" + SoldOut;
        }
        // Tükenenleri Gizle Seçeneğini Kontrol Eder

        // Sıralama Seçeneğini Kontrol Eder
        $PrcSort = $("#PrdSort > li > label.checked");
        var SelectedSortID = $PrcSort.parent().children("input").val();
        if (SelectedSortID != null && SelectedSortID != "" && SelectedSortID != undefined) {
            params += "&o=" + SelectedSortID;
        }
        // Sıralama Seçeneğini Kontrol Eder

        // Color Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedColors = "";
        $("#Colors li.selected").each(function (index) { // Seçili renkleri döndürür
            SelectedColors += $(this).children("input").val() + ",";
        });

        if (SelectedColors != "" && SelectedColors != null && SelectedColors != undefined) {
            params += "&c=" + SelectedColors.substring(0, SelectedColors.length - 1); // Substring ile sondaki virgül silinir
        }
        // Color Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Size Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedSizes = "";
        $("#Sizes li.selected").each(function (index) { // Seçili bedenleri döndürür
            SelectedSizes += $(this).children("input").val() + ",";
        });

        if (SelectedSizes != "" && SelectedSizes != null && SelectedSizes != undefined) {
            params += "&s=" + SelectedSizes.substring(0, SelectedSizes.length - 1); // Substring ile sondaki virgül silinir
        }
        // Size Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedProperties = "";
        $("#Properties li.selected").each(function (index) { // Seçili özellikleri döndürür
            SelectedProperties += $(this).children("input").val() + ",";
        });

        if (SelectedProperties != "" && SelectedProperties != null && SelectedProperties != undefined) {
            params += "&prp=" + SelectedProperties.substring(0, SelectedProperties.length - 1); // Substring ile sondaki virgül silinir
        }
        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Kumaş Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedCloth = "";
        $("#Cloth li.selected").each(function (index) { // Seçili bedenleri döndürür
            SelectedCloth += $(this).children("input").val() + ",";
        });

        if (SelectedCloth != "" && SelectedCloth != null && SelectedCloth != undefined) {
            params += "&clh=" + SelectedCloth.substring(0, SelectedCloth.length - 1); // Substring ile sondaki virgül silinir
        }
        // Kumaş Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Online Özel Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedOnlOzl = "";
        $("#JustOnline li.selected").each(function (index) { // Seçili online özel olanları döndürür
            SelectedOnlOzl += $(this).children("input").val() + ",";
        });

        if (SelectedOnlOzl != "" && SelectedOnlOzl != null && SelectedOnlOzl != undefined) {
            params += "&onlozl=" + SelectedOnlOzl.substring(0, SelectedOnlOzl.length - 1); // Substring ile sondaki virgül silinir
        }
        // Online Özel Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Kalıp Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedMold = "";
        $("#Molds li.selected").each(function (index) { // Seçili kalıp olanları döndürür
            SelectedMold += $(this).children("input").val() + ",";
        });

        if (SelectedMold != "" && SelectedMold != null && SelectedMold != undefined) {
            params += "&mld=" + SelectedMold.substring(0, SelectedMold.length - 1); // Substring ile sondaki virgül silinir
        }
        // Kalıp Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Erp Badge Metin Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedErpBadgeText = "";
        $("#ErpBadgeTexts li.selected").each(function (index) { // Seçili erp badge metin olanları döndürür

            SelectedErpBadgeText += $(this).children("input").val() + ",";
        });

        if (SelectedErpBadgeText != "" && SelectedErpBadgeText != null && SelectedErpBadgeText != undefined) {
            params += "&btxt=" + SelectedErpBadgeText.substring(0, SelectedErpBadgeText.length - 1); // Substring ile sondaki virgül silinir
        }
        // Erp Badge Metin Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Price Filtresini kontrol Eder, Varsa Params Değerine Ekler
        if ($("#SliderValue").val() != null && $("#SliderValue").val() != "" && $("#SliderValue").val() != undefined && $("#SliderValue").val() != "0-500") {
            params += "&prc=" + $("#SliderValue").val();
        }
        // Price Filtresini kontrol Eder, Varsa Params Değerine Ekler
    }
    //console.log("params: " + params);
    return params;
}

function SetUrl(params) {
    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var newURL = location.pathname + "?" + params;

    if (ios == false) {
        window.history.replaceState({}, "", newURL); // Sayfa URL'inin değişmesini sağlar
    }
    else {
        history.pushState({}, "", newURL);
    }
}

//function SetUrl() {
//    var CurrentPageTitle = $("#PageTitle").val();
//    var CurrentH1Title = $("#PageH1").val();
//    var CustomFiltersTitle = "";
//    var CustomFilterURL = "";
//    var i = 0;

//    $("#Properties li.selected").each(function (index) { // Seçili özellikleri döndürür
//        if (i == 0) {
//            CustomFiltersTitle += $(this).find(".checkText").text();
//            CustomFilterURL += $(this).find("input").attr("data-url");
//        }
//        else {
//            CustomFiltersTitle += ", " + $(this).find(".checkText").text();
//            CustomFilterURL += "-" + $(this).find("input").attr("data-url");
//        }
//        i++;
//    });

//    $("#Cloth li.selected").each(function (index) { // Seçili bedenleri döndürür
//        if (i == 0) {
//            CustomFiltersTitle += $(this).find(".checkText").text();
//            CustomFilterURL += $(this).find("input").attr("data-url");
//        }
//        else {
//            CustomFiltersTitle += ", " + $(this).find(".checkText").text();
//            CustomFilterURL += "-" + $(this).find("input").attr("data-url");
//        }
//        i++;
//    });

//    $("h1").html(CustomFiltersTitle + " " + CurrentH1Title);

//    CustomFiltersTitle = CustomFiltersTitle + " " + CurrentPageTitle;
//    $(document).prop('title', CustomFiltersTitle);

//    var Hash = window.location.href.slice(window.location.href.indexOf('?') + 1);
//    var CurrentPath = $("#ParentCatalogURL").val();


//    if (CustomFilterURL != "") {
//        CustomFilterURL += "--";
//    }

//    window.history.pushState('', '', "/", CurrentPath.replace("{ReplacePlace}", CustomFilterURL) + "?" + Hash);
//}

// Sayfalama İşleminden Önce URL History Oluşturur
function GenerateUrlHistoy() {

    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // Var olan QueryString'i okur
    var PathName = window.location.pathname; // Bulunan kataloğun url'ini alır
    var CurrentURL = "";

    if (getQueryFilter.indexOf("=") != "-1") {
        CurrentURL = PathName + "?" + getQueryFilter;
    }
    else {
        CurrentURL = PathName;
    }

    if (CurrentURL != null && CurrentURL != "" && CurrentURL != undefined) {
        window.history.pushState('', '', CurrentURL);
    }
}

// Sayfalar Arası Gezerken Browser Back/Prev Butonlarını Kontrol Eder
function BrowserBackAndPrevButtonControl() {
    $(window).on('popstate', function (event) {

        var vars = [], hash;
        var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        var IsCatalogFirsPage = true;

        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "p") {
                getPageByPageNo(hash[1], "true");
                IsCatalogFirsPage = false;
            }
        }

        if (IsCatalogFirsPage == true) {
            getPageByPageNo(1, "true");
        }

    });
}

// Seçili Filtreleri Ekler
function GetSelectedFilter() {

    $SelectedFilterBody = $(".SelectedFilter .SelectedFilterBody ul");
    $SelectedFilterBody.html("");

    var Color = getStandartMessages("Renk");
    var Size = getStandartMessages("Beden");
    var Price = getStandartMessages("Fiyat");
    var Propertie = getStandartMessages("Ozellik");
    var Cloth = getStandartMessages("Kumas");
    var ProductGroup = getStandartMessages("Kategori");
    var Department = getStandartMessages("Departman");
    var Season = getStandartMessages("Sezon");
    var OnlineOzel = getStandartMessages("OnlineOzel");
    var Kalip = getStandartMessages("Kalip");
    var ErpBadgeText = getStandartMessages("ErpBadgeText");

    // Ürün Grubu Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#ProductGroup li.selected").each(function (index) { // Seçili renkleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='ProductGroup'></span>";
        $li += "<span class='SelectedFilterTitle'>" + ProductGroup + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Ürün Grubu Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Departman Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Departments li.selected").each(function (index) { // Seçili renkleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='Department'></span>";
        $li += "<span class='SelectedFilterTitle'>" + Department + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Departman Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Sezon Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Seasons li.selected").each(function (index) { // Seçili renkleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='Season'></span>";
        $li += "<span class='SelectedFilterTitle'>" + Season + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Sezon Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Color Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Colors li.selected").each(function (index) { // Seçili renkleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='color'></span>";
        $li += "<span class='SelectedFilterTitle'>" + Color + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Color Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Size Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Sizes li.selected").each(function (index) { // Seçili bedenleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='size'></span>";
        $li += "<span class='SelectedFilterTitle'>" + Size + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Size Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Özellik Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Properties li.selected").each(function (index) { // Seçili bedenleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='properties'></span>";
        $li += "<span class='SelectedFilterTitle'>" + Propertie + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Özellik Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Kumaş Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Cloth li.selected").each(function (index) { // Seçili bedenleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='cloth'></span>";
        $li += "<span class='SelectedFilterTitle'>" + Cloth + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Kumaş Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Online Özel Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#JustOnline li.selected").each(function (index) {

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='onlozl'></span>";
        $li += "<span class='SelectedFilterTitle'>" + OnlineOzel + "</span>";
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Online Özel Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Kalıp Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Molds li.selected").each(function (index) { // Seçili bedenleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='mold'></span>";
        $li += "<span class='SelectedFilterTitle'>" + Kalip + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Kalıp Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Erp Badge Metin Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    $("#ErpBadgeTexts li.selected").each(function (index) { // Seçili filtreleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='erpbadgetext'></span>";
        $li += "<span class='SelectedFilterTitle'>" + ErpBadgeText + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Erp Badge Metin Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Price Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $PriceSlide = $("#SliderValue").val();
    if ($PriceSlide != "0-500" && $PriceSlide != null && $PriceSlide != "" && $PriceSlide != undefined) {
        $li = "<li>";
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $PriceSlide + "' data-type='price'></span>";
        $li += "<span class='SelectedFilterTitle'>" + Price + ":</span> " + $PriceSlide;
        $li += "</li>";

        $SelectedFilterBody.append($li);
    }
    // Price Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler 

    if ($SelectedFilterBody.find("li").length > 0) {
        OpenCloseSelectedFilterArea("Up"); // Filtre seçiliyse Seçili Filtreler alanını açar

        // Tüm filtreleri temizleme seçeneği
        $li = "<li><span class='ClearAllFilter'>" + getStandartMessages("SecimleriTemizle") + "</span></li>";
        $SelectedFilterBody.append($li);
        // Tüm filtreleri temizleme seçeneği
    }
    else {
        OpenCloseSelectedFilterArea("Down"); // Filtre seçili değilse Seçili Filtreler alanını kapatır
    }
}

// Seçili Filtreleri Kaldıran Fonksiyon
function ClearSelectedFilter($selectedVal, $selectedType) {
    var selectedVal = $selectedVal;
    var selectedType = $selectedType;

    if (selectedVal != null &&
        selectedVal != "" &&
        selectedVal != undefined &&
        selectedType != null &&
        selectedType != "" &&
        selectedType != undefined) {

        if (selectedType == "color") { // Filtre alanındaki seçili Color fitresini kaldırır
            $("#Colors li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Colors li label[for='c-" + selectedVal + "']").removeClass("c_on");
            $("#Colors li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "ProductGroup") { // Filtre alanındaki seçili Ürün Grubu fitresini kaldırır
            $("#ProductGroup li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#ProductGroup li label[for='ct-" + selectedVal + "']").removeClass("c_on");
            $("#ProductGroup li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "Department") { // Filtre alanındaki seçili Departman fitresini kaldırır
            $("#Departments li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Departments li label[for='dp-" + selectedVal + "']").removeClass("c_on");
            $("#Departments li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "Season") { // Filtre alanındaki seçili Sezon fitresini kaldırır
            $("#Seasons li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Seasons li label[for='sea-" + selectedVal + "']").removeClass("c_on");
            $("#Seasons li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "size") { // Filtre alanındaki seçili Size fitresini kaldırır
            $("#Sizes li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Sizes li label[for='s-" + selectedVal + "']").removeClass("c_on");
            $("#Sizes li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "properties") { // Filtre alanındaki seçili Özellik fitresini kaldırır
            $("#Properties li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Properties li label[for='s-" + selectedVal + "']").removeClass("c_on");
            $("#Properties li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "cloth") { // Filtre alanındaki seçili Kumaş fitresini kaldırır
            $("#Cloth li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Cloth li label[for='s-" + selectedVal + "']").removeClass("c_on");
            $("#Cloth li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "onlozl") {
            $("#JustOnline li input[value='onlozl-1']").removeAttr("checked");
            $("#JustOnline li label[for='onlozl-1']").removeClass("c_on");
            $("#JustOnline li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "mold") { // Filtre alanındaki seçili Kalıp fitresini kaldırır
            $("#Molds li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Molds li label[for='s-" + selectedVal + "']").removeClass("c_on");
            $("#Molds li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "erpbadgetext") { // Filtre alanındaki seçili Erp Badge Metin fitresini kaldırır
            $("#ErpBadgeTexts li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#ErpBadgeTexts li label[for='btxt-" + selectedVal + "']").removeClass("c_on");
            $("#ErpBadgeTexts li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "price") { // Filtre alanındaki seçili Price fitresini kaldırır
            $("#MinPrice").val("0");
            $("#MaxPrice").val("500");
            $("#SliderValue").val("0-500");
            var slider = document.getElementById('PriceSlider');
            slider.noUiSlider.reset();
            GetPageByFilter();
        }
    }
}

// Tüm Filtreleri Kaldıran Fonksiyon
function ClearAllFilter($IsReload) {

    // Color filtrelerini kaldırır
    $("#Colors li input").removeAttr("checked");
    $("#Colors li label").removeClass("c_on");
    $("#Colors li input").parent("li").removeClass("selected");

    // Ürün Grubu filtrelerini kaldırır
    $("#ProductGroup li input").removeAttr("checked");
    $("#ProductGroup li label").removeClass("c_on");
    $("#ProductGroup li input").parent("li").removeClass("selected");

    // Departman filtrelerini kaldırır
    $("#Departments li input").removeAttr("checked");
    $("#Departments li label").removeClass("c_on");
    $("#Departments li input").parent("li").removeClass("selected");

    // Sezon filtrelerini kaldırır
    $("#Seasons li input").removeAttr("checked");
    $("#Seasons li label").removeClass("c_on");
    $("#Seasons li input").parent("li").removeClass("selected");

    // Size filtrelerini kaldırır
    $("#Sizes li input").removeAttr("checked");
    $("#Sizes li label").removeClass("c_on");
    $("#Sizes li input").parent("li").removeClass("selected");

    // Özellik filtrelerini kaldırır
    $("#Properties li input").removeAttr("checked");
    $("#Properties li label").removeClass("c_on");
    $("#Properties li input").parent("li").removeClass("selected");

    // Kumaş filtrelerini kaldırır
    $("#Cloth li input").removeAttr("checked");
    $("#Cloth li label").removeClass("c_on");
    $("#Cloth li input").parent("li").removeClass("selected");

    // Online Özel filtrelerini kaldırır
    $("#JustOnline li input").removeAttr("checked");
    $("#JustOnline li label").removeClass("c_on");
    $("#JustOnline li input").parent("li").removeClass("selected");

    // Kalıp filtrelerini kaldırır
    $("#Molds li input").removeAttr("checked");
    $("#Molds li label").removeClass("c_on");
    $("#Molds li input").parent("li").removeClass("selected");

    // Kalıp filtrelerini kaldırır
    $("#ErpBadgeTexts li input").removeAttr("checked");
    $("#ErpBadgeTexts li label").removeClass("c_on");
    $("#ErpBadgeTexts li input").parent("li").removeClass("selected");

    // Price filtresini kaldırır
    $("#MinPrice").val("0");
    $("#MaxPrice").val("500");
    $("#SliderValue").val("0-500");
    var slider = $('#PriceSlider');

    //if ($('#PriceSlider').length > 0) {
    //    slider.noUiSlider.reset();
    //}

    if ($IsReload == "true") {
        GetPageByFilter(); // Filtreleri temizledikten sonra istek yapar
    }
}

// Mobil Filtre ve Sıralama Alanını Aldığı Değere Göre Açıp/Kapatan Fonksiyon
function MobilSortFilterAreaOpenOrClose($AreaName) {
    if ($AreaName != null && $AreaName != "" && $AreaName != undefined) {

        if ($AreaName == ".MobilSortArea") {
            $($AreaName).slideToggle("normal");
            $(".backdrop").toggleClass("openFilter");
        }
        else {
            $(".MobilSortArea").slideUp("normal", function () {
                $($AreaName).toggleClass("open");
                $(".backdrop").removeClass("openFilter");
                $(".backdrop").toggleClass("rightMenu");
            });
        }
    }
}

// Dataleyer
function ProductClickForDataLayer() {
    $(".Products .ProductList .urunlist  a").click(function () {

        event.preventDefault();

        var redirectUrl = $(this).attr("href");
        var ProductID = $(this).attr("data-product");
        var ColorID = $(this).attr("data-color");
        var LangID = $("#LangID").val();
        var SmallLangCode = $("#SmallLangCode").val();

        var CurrentCatalogID = $("#PID").val();

        if (CurrentCatalogID == null || CurrentCatalogID == "" || CurrentCatalogID == undefined) {
            CurrentCatalogID = $("#PgCatalogs").val();
        }

        if (ProductID == null || ProductID == "" || ProductID == undefined || ColorID == null || ColorID == "" || ColorID == undefined) {
            document.location = redirectUrl;
        }
        else {

            var params = "ProductID=" + ProductID + "&ColorID=" + ColorID + "&LangID=" + LangID + "&SmallLangCode=" + SmallLangCode + "&CurrentCatalogID=" + CurrentCatalogID;

            $AjaxLoader = $(".PrdContainer .AjaxLoaderDiv");
            $AjaxLoader.addClass("AjaxLoaderPleaseWait");

            var SelectedProductID = $(this).attr("data-product") + "-" + $(this).attr("data-color");

            var i = 0;
            $(".PrdContainer .Products .urunlist").each(function () {
                i++;

                var CurrentProductID = $(this).find("a").attr("data-product") + "-" + $(this).find("a").attr("data-color");

                if (SelectedProductID == CurrentProductID) {
                    return false;
                }
            });

            if (i > 0) {
                params += "&Position=" + i;
            }

            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/Cat/GetProductDataLayerData",
                data: params,
                cache: false,
                success: function (data) {
                    if (data == null || data == "" || data == undefined) {
                        document.location = redirectUrl;
                    }
                    else {
                        window.dataLayer = window.dataLayer || [];
                        dataLayer.push({
                            "event": "eec.impressionClick",
                            "ecommerce": {
                                "click": {
                                    "actionField": {
                                        "list": "Related products"
                                    },
                                    "products": [JSON.parse(data)]
                                }
                            }
                        });

                        document.location = redirectUrl;
                    }
                },
                error: function (data) {
                    document.location = redirectUrl;
                }
            });
        }

        // return false;
    });
}